import React from "react";
import styles from "./AccessDeniedPage.module.scss";
import { useTranslation } from "react-i18next";

export default function AccessDeniedPage(props: AccessDeniedPageProps) {
    const { t } = useTranslation();

    return (
        <div className={styles.page}>
            <div className={styles.content}>
                <div className={styles.illustration} aria-hidden="true">
                    <svg width="100" height="120" viewBox="0 0 100 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="10" y="52" width="80" height="62" rx="10" fill="#E5E5E5"/>
                        <path d="M28 56 L28 34 A22 22 0 0 1 72 34 L72 56" stroke="#BBBFBD" strokeWidth="10" fill="none" strokeLinecap="round"/>
                        <circle cx="50" cy="79" r="11" fill="#BBBFBD"/>
                        <rect x="46" y="79" width="8" height="14" rx="4" fill="#BBBFBD"/>
                    </svg>
                </div>

                <h1 className={styles.title}>{t("ERROR_AccessDenied")}</h1>
                <p className={styles.message}>{t("ERROR_AccessDeniedMessage")}</p>
                <a className={styles.email} href="mailto:flintlinksupport@flintlink.com">
                    flintlinksupport@flintlink.com
                </a>
                <p className={styles.footText}>{t("ERROR_AccessDeniedFootText")}</p>

                {props.message && (
                    <p className={styles.debugMessage}>
                        <strong>ERROR MESSAGE:</strong>{" "}
                        <span className="h5 text-danger">{props.message}</span>
                    </p>
                )}
            </div>
        </div>
    );
}

export interface AccessDeniedPageProps {
    message?: string;
}
